import gql from 'graphql-tag';

import DAILY_EXPANDED_FRAGMENT from './DAILY_EXPANDED_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY_EXPANDED = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunDailyExpanded
			}
			count
		}
	}
	${DAILY_EXPANDED_FRAGMENT}
`;

export default GET_SERVICE_RUNS_DAILY_EXPANDED;
